const API_URL = "http://local.spectrebowling.com";

const DEBOUNCE_INPUT_PROPS = { minLength: 3, debounceTimeout: 1000 };

module.exports = {
  appConfig: {},
  validation: {
    EMAIL: (value) =>
      value &&
      !/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
        value
      )
        ? "Invalid email address"
        : undefined,
    PASSWORD: (value) =>
      value &&
      !/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[A-Za-z\d$@$!`~!^%?/]{6,}$/.test(value)
        ? "Invalid password (Must be at least 1 number, 1 upper case character)"
        : undefined,
    REQUIRED: (value) =>
      value || typeof value === "number" ? undefined : "Required",
  },
  API_URL: `${API_URL}/api`,
  DEBOUNCE_INPUT_PROPS,
  APP_VERSION: process.env.REACT_APP_VERSION || "3.148",
};
